import React, { useEffect, useState } from 'react';
import SwipeCard from './SwipeCard';
import Icon from '../../components/Icon';
import { EmptyState } from '../../components/ui';

const VISIBLE_CARDS = 3;

export default function SwipeDeck({ people, onDecide, onOpenProfile, onReset, onBrowse }) {
  const [pending, setPending] = useState(null);
  const top = people[0];

  // Reset the queued decision whenever a new card reaches the top of the deck.
  useEffect(() => {
    setPending(null);
  }, [top?._id]);

  useEffect(() => {
    if (!top) return undefined;
    const onKeyDown = (e) => {
      if (e.target.closest?.('input, textarea')) return;
      if (e.key === 'ArrowLeft') setPending('pass');
      else if (e.key === 'ArrowRight') setPending('like');
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [top]);

  if (!top) {
    return (
      <EmptyState
        icon="check"
        title="You're all caught up"
        text="No new people to see right now. Reset your passes to go through them again, or browse everyone."
        action={
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', justifyContent: 'center' }}>
            <button type="button" className="btn btn-secondary" onClick={onReset}>
              <Icon name="refresh" size={17} />
              Start over
            </button>
            <button type="button" className="btn btn-gradient" onClick={onBrowse}>
              <Icon name="grid" size={17} />
              Browse everyone
            </button>
          </div>
        }
      />
    );
  }

  return (
    <div>
      <div className="deck">
        {people
          .slice(0, VISIBLE_CARDS)
          .map((person, index) => (
            <SwipeCard
              key={person._id}
              person={person}
              depth={index}
              forcedDecision={index === 0 ? pending : null}
              onDecide={onDecide}
              onOpenProfile={onOpenProfile}
            />
          ))
          .reverse()}
      </div>

      <div className="deck-actions">
        <button
          type="button"
          className="deck-btn deck-btn-pass"
          onClick={() => setPending('pass')}
          disabled={!!pending}
          aria-label={`Pass on ${top.username}`}
        >
          <Icon name="x" size={26} strokeWidth={2.2} />
        </button>
        <button
          type="button"
          className="deck-btn deck-btn-info"
          onClick={() => onOpenProfile(top)}
          aria-label={`View ${top.username}'s profile`}
        >
          <Icon name="info" size={20} />
        </button>
        <button
          type="button"
          className="deck-btn deck-btn-like"
          onClick={() => setPending('like')}
          disabled={!!pending}
          aria-label={`Like ${top.username}`}
        >
          <Icon name="heart" size={28} filled strokeWidth={0} />
        </button>
      </div>

      <p className="deck-hint">Drag the card, use the buttons, or press ← / → · tap the card for full profile</p>
    </div>
  );
}
